exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_weather_2dbffRq2jhoccoCsyaUG2B {\n  height: 100%;\n  box-sizing: border-box;\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n.IA_weatherIcon_27dSK_7_36nXukG10H0-N4 {\n  height: 65%;\n  width: fit-content;\n}\n\n.IA_weatherTemperature_LOAY3nfs_ATQAu9HY4NgK {\n  position: relative;\n  text-align: left;\n\n}\n\n.IA_weatherArea_1swIATy8EAv5HnfiV9M5ZP {\n  position: relative;\n  text-align: left;\n  font-weight: lighter;\n  clear: right;\n}", ""]);

// Exports
exports.locals = {
	"IA_weather": "IA_weather_2dbffRq2jhoccoCsyaUG2B",
	"IA_weatherIcon": "IA_weatherIcon_27dSK_7_36nXukG10H0-N4",
	"IA_weatherTemperature": "IA_weatherTemperature_LOAY3nfs_ATQAu9HY4NgK",
	"IA_weatherArea": "IA_weatherArea_1swIATy8EAv5HnfiV9M5ZP"
};